export default class tipoTrabajo{
	constructor($scope,
				$routeParams,
				method,
				tipoTrabajoService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(tipoTrabajoService);
			break;
			case 'new':
				this.create(tipoTrabajoService);
			break;
			case 'view':
				this.view($routeParams,
                    tipoTrabajoService);
			break;
		}
	}

	list(tipoTrabajoService){

        let self = this.scope;
        tipoTrabajoService.getAll().then((resp, err) => {
			self.tiposTrabajos = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.tiposTrabajos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, tipoTrabajoService);

        /*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoTrabajoService.delete({_id: id}).then((resp) => {
                    if (resp.data.success === true) {
                        this.toastr.success('Tipo de trabajo eliminado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al eliminar el tipo de trabajo!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
		*/
	}

	create(tipoTrabajoService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoTrabajoService.save(this.scope.tipoDeTrabajo).then((resp) => {
                    this.toastr.success('Tipo de trabajo creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_trabajo');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al crear el tipo de trabajo!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

	view($routeParams,
         tipoTrabajoService){

		this.scope.aux = {};
        tipoTrabajoService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.tipoDeTrabajo = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoTrabajoService.update(this.scope.tipoDeTrabajo).then((resp) => {
                    this.toastr.success('Tipo de trabajo modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_trabajo');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al modificar el tipo de trabajo!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Tipo de Trabajo</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el Tipo de Trabajo: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.tiposTrabajos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Tipo de Trabajo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Tipo de Trabajo!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/tipo_trabajo/tipo_trabajo.js